import { ReactNode } from 'react';
import { useLang } from 'hooks/lang';

import { Tag, TagProps, Tooltip } from 'components/Blocks';
import { SquareMouseIcon } from 'components/Icons';

interface ProjectTypeTagProps extends Partial<Omit<TagProps, 'name'>> {
  children?: never;

  projectType: string;
  icon?: ReactNode;
}

export function ProjectTypeTag({ projectType, icon, ...tagProps }: ProjectTypeTagProps) {
  const { t } = useLang();

  return (
    <Tooltip ensurePresence content={t('project-type')}>
      <Tag
        color="primary"
        name={
          <>
            {icon ?? <SquareMouseIcon size={16} />}
            {t(projectType)}
          </>
        }
        {...tagProps}
      />
    </Tooltip>
  );
}
